import { clsx } from "clsx";
import React from "react";

import * as styles from "./Avatar.css"

type Props = {
    firstName?: string;
    lastName?: string;
    size?: "sm" | 'lg'
} & React.HTMLAttributes<HTMLDivElement>;

function toInitial(name: string | undefined) {
    const trimmed = name?.trim();
    return trimmed ? trimmed.substring(0, 1).toUpperCase() : "";
}

export const Avatar: React.FC<Props> = ({ firstName, lastName, size="sm", className, ...elementProps }) => {
    const f = toInitial(firstName);
    const l = toInitial(lastName);

    if (!f && !l) return null;
    return <div className={clsx(styles.avatar({ size }), className)} {...elementProps}>
        {f}{l}
    </div>;
}   